import { Skeleton } from '@heidi/design-system/skeleton';

/**
 * Placeholder shown while the lazy card body chunk loads (see
 * {@link PatientListIntroductionModal}). Mirrors the awareness card shape — a
 * hero panel above a title, description, and trailing button row.
 */
export const PatientListIntroductionModalLoading = () => (
  <div className="flex flex-col">
    <Skeleton className="h-[120px] w-full rounded-none" />
    <div className="flex flex-col gap-4 px-4 pb-4 pt-2">
      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-3/4" />
      </div>
      <div className="flex justify-end gap-2">
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-28" />
      </div>
    </div>
  </div>
);
